import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { Layout } from "@components/Layout/Layout";
import { useEffect } from "react";
import ms from "ms";
import router from "next/router";
import TwitterIcon from "@public/social-icons/twitter.svg";
import LinkedInIcon from "@public/social-icons/linkedin.svg";
import GitHubIcon from "@public/social-icons/github.svg";
import InstagramIcon from "@public/social-icons/instagram.svg";
import YouTubeIcon from "@public/social-icons/youtube.svg";
import Image from "next/image";
import { JobPostPreview } from "@components/JobPost/JobPostPreview";
import { organisationSizeToLabel } from "@utils/enumToLabel/organisationSizeToLabel";
import { OrganizationJsonLd } from "@components/JsonLd/OrganizationJsonLd";
function OrganisationPage(param) {
    let { organisation , activeJobPosts , expiredJobPosts  } = param;
    var ref, ref1;
    const pageTitle = organisation ? "".concat(organisation.name, " Careers") : "Not Found.";
    const metaDescription = "Find the latest ".concat(organisation === null || organisation === void 0 ? void 0 : organisation.name, " jobs with JavaScript. Apply for ").concat(organisation === null || organisation === void 0 ? void 0 : organisation.name, " jobs.");
    // If no organisation, redirect to home page after a short delay.
    useEffect(()=>{
        if (!organisation) {
            const timer = setTimeout(()=>router.push("/"), ms("10s"));
            return ()=>{
                clearTimeout(timer);
            };
        }
    }, []);
    const orgName = (organisation === null || organisation === void 0 ? void 0 : organisation.name) || (organisation === null || organisation === void 0 ? void 0 : (ref = organisation.webUrl) === null || ref === void 0 ? void 0 : ref.replace("https://", ""));
    return /*#__PURE__*/ _jsxs(Layout, {
        pageTitle: pageTitle,
        metaDescription: metaDescription,
        canonicalUrl: "/company/".concat(organisation === null || organisation === void 0 ? void 0 : organisation.slug),
        hasRobotsNoIndex: !organisation,
        bodyCN: "px-4",
        children: [
            /*#__PURE__*/ _jsx(OrganizationJsonLd, {
                organisation: organisation
            }),
            organisation ? /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-row space-x-4",
                        children: [
                            (organisation === null || organisation === void 0 ? void 0 : organisation.favicon) ? /*#__PURE__*/ _jsx("div", {
                                className: "",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    className: "rounded",
                                    width: 48,
                                    height: 48,
                                    src: "".concat(process.env.NEXT_PUBLIC_SUPABASE_PROJECT_URL, "/storage/v1/object/public/public").concat(organisation === null || organisation === void 0 ? void 0 : organisation.favicon),
                                    alt: "".concat((organisation === null || organisation === void 0 ? void 0 : organisation.name) || "", " logo")
                                })
                            }) : /*#__PURE__*/ _jsx("div", {
                                className: "flex justify-center items-center w-12 h-12 rounded bg-gray-100 ",
                                children: organisation === null || organisation === void 0 ? void 0 : (ref1 = organisation.name) === null || ref1 === void 0 ? void 0 : ref1[0]
                            }),
                            /*#__PURE__*/ _jsx("h1", {
                                className: "text-4xl font-black",
                                children: orgName
                            })
                        ]
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.size) ? /*#__PURE__*/ _jsx("div", {
                        className: "my-2 ",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "px-1.5 py-1 text-gray-600 bg-gray-100 rounded-sm text-xs font-medium ",
                            children: organisationSizeToLabel[organisation === null || organisation === void 0 ? void 0 : organisation.size]
                        })
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-4",
                        children: organisation === null || organisation === void 0 ? void 0 : organisation.about
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-4",
                        children: ((organisation === null || organisation === void 0 ? void 0 : organisation.webUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl)) && /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-row mt-2 space-x-4 text-sm",
                            children: [
                                (organisation === null || organisation === void 0 ? void 0 : organisation.webUrl) && /*#__PURE__*/ _jsx("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.webUrl,
                                    target: "_blank",
                                    rel: "nofollow noopener noreferrer",
                                    className: "hover:underline",
                                    children: organisation === null || organisation === void 0 ? void 0 : organisation.webUrl
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl) && /*#__PURE__*/ _jsx("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl,
                                    title: "Twitter",
                                    target: "_blank",
                                    children: /*#__PURE__*/ _jsx(TwitterIcon, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl) && /*#__PURE__*/ _jsx("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl,
                                    title: "LinkedIn",
                                    target: "_blank",
                                    children: /*#__PURE__*/ _jsx(LinkedInIcon, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl) && /*#__PURE__*/ _jsx("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl,
                                    title: "GitHub",
                                    target: "_blank",
                                    children: /*#__PURE__*/ _jsx(GitHubIcon, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.instagramUrl) && /*#__PURE__*/ _jsx("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.instagramUrl,
                                    title: "Instagram",
                                    target: "_blank",
                                    children: /*#__PURE__*/ _jsx(InstagramIcon, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.youtubeUrl) && /*#__PURE__*/ _jsx("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.youtubeUrl,
                                    title: "YouTube",
                                    target: "_blank",
                                    children: /*#__PURE__*/ _jsx(YouTubeIcon, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("h2", {
                        className: "mt-14 mb-2 text-2xl font-bold",
                        children: [
                            orgName,
                            " jobs for JavaScript developers"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "max-w-prose",
                        children: activeJobPosts.map((jobPost)=>/*#__PURE__*/ _jsx(JobPostPreview, {
                                jobPost: jobPost,
                                hasOrganisationAbout: false
                            }, jobPost.id))
                    })
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: "py-40 text-2xl font-bold text-center",
                children: "Company not found."
            })
        ]
    });
}
export var __N_SSP = true;
export default _withSuperJSONPage(OrganisationPage);
